import React, { useState, useContext ,useEffect} from 'react';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import Logo from '../../assets/logo.png'; 
import '../../styles/external_receipt.css';
import * as Constants from '../../constants';
import BackLoader from '../../components/backloader';
import JisButton from '../../components/controls/jisButton';
function InternalReceipt() {
 const [receipt, setReceipt]=useState(null)
 const {refid} = useParams();
 const [loading, setLoading]=useState(false);
    useEffect(() => {
        onLoad();
  }, []);

  const onLoad= async()=>{
              //for account registration
    try {
      console.log(`inside receipt ${refid}`)
        var mid=0;
        if(refid.includes('JISI')){
          var rs=refid.replace('JISI','');
          mid=parseInt(rs);
          console.log(` the final ${refid} as ${mid}`);
        }else{
          mid=refid;
        }
        setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/payment/internal-receipt/${mid}`, { 
            method: 'GET',  
            headers: {  'Content-Type': 'application/json' }
            });  
        const data = await resp.json();
        setLoading(false);

        setReceipt(data)

        } catch (error) {
        setLoading(false);
        console.error(error);   
        }
  }

  return (
    <div>
     <div className="newreceipt">
        <div className="header">
          <img src={Logo} alt="Lagos Logo" />
          <div className="title">Lagos State Judiciary Information System</div>
          <a>Payment Receipt</a>
        </div>
    
        <div className="section row">
          <div className="col"><strong>Suit Number:</strong> {receipt?.casenumber}</div>
          <div className="col"><strong>Amount (₦):</strong> {receipt?.amount}</div>
          <div className="col"><strong>Paid On:</strong>{receipt?.paidon} </div>

          <div className="col"><strong>PayerID:</strong>{receipt?.payerid} </div>
          <div className="col"><strong>Payment By:</strong>{receipt?.payby} </div>
          <div className="col"><strong>Transaction Number:</strong>{receipt?.transid} </div>
          {receipt?.webguid!=null && <div className="col"><strong>Bill Reference:</strong>{receipt?.webguid} </div>}
          <div className="col"><strong>Revenue Code:</strong> 51102</div>
          <div className="col"><strong>Payment Address:</strong>High Court of Lagos State</div>
       
        </div>
    
        <table>
          <thead>
             
            <tr >
              <th>Sl.No</th>
              <th>Description</th>
              <th>Qty</th>
              <th>Fee</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody>
              <tr>
              <td>1</td>
              <td>{receipt?.lines[0]?.title}</td>
              <td>{1}</td>
              <td>{1500}</td>
              <td>{1500}</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Exhibit(s)</td>
              <td>{receipt?.lines.length-1}</td>
              <td></td>
              <td>{receipt?.amount-1500}</td>
            </tr>
            
          </tbody>
        </table>
    
        <div className="totals">
          Revenue Amount: N{receipt?.amount}
          Total: ₦<br />
          Service Fee: ₦0<br />
          Convenience Fee: ₦0<br />
          <strong>Grand Total: ₦{receipt?.amount}</strong>
        </div>
      </div>
      <div className='no-print' style={{textAlign:'right'}}><JisButton onClick={()=>window.print()}>Print</JisButton></div>
      <BackLoader open={loading} />
    </div>
  );
}

export default InternalReceipt;